import { render, staticRenderFns } from "./HistoryCustomer.vue?vue&type=template&id=04e29462&"
import script from "./HistoryCustomer.vue?vue&type=script&lang=js&"
export * from "./HistoryCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports